import { API_URL } from "./http";

const addOrganization = () => `${API_URL}/organization`;

const refreshToken = () => `${API_URL}/refresh-token`;

const getSingleOrganization = () =>
  `${API_URL}/organization-admin/organization`;

const updateOrganization = () => `${API_URL}/organization-admin/organization`;

const getAllCountries = () => `${API_URL}/country`;

// const getAllSectors = () => `${API_URL}/sector`;

const getAllSectors = (partnerId) =>
  // `${API_URL}/end-user/sector/get-all-sectors/${partnerId}`;
  `${API_URL}/end-user/sector/${partnerId}`;

// const getSubSectors = (sectorId) => `${API_URL}/sector/${sectorId}`;
const getSubSectors = (sectorId) => `${API_URL}/end-user/get/sub-sector/${sectorId}`;

const createMicrosite = () =>
  `${API_URL}/organization-admin/organization/microsite`;

const getAllMicrosites = () =>
  `${API_URL}/organization-admin/organization/microsite`;

const createContactUsSales = (micrositeId, id) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/contact-us`
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/contact-us?tabConfigId=${id}`;

const createContactUsAddress = (micrositeId, tabConfigId) =>
  `${API_URL}/organization-admin/organization/microsite/contact-us/address?micrositeId=${micrositeId}&tabConfigId=${tabConfigId}`;
// `${API_URL}/organization-admin/organization/microsite/${micrositeId}/contact-us&tabconfigId=${tabConfigId}`;

const updateContactUsSales = (id, micrositeId) =>
  `${API_URL}/organization-admin/organization/microsite/contact-us/${id}`;

const getContactUsDetails = (tabName, micrositeId) => {
  if (tabName === "REVIEWS") {
    return null;
  } else {
    return `${API_URL}/organization-admin/organization/microsite/${micrositeId}/contact-us?contactUsTypeEnum=${tabName}`;
  }
};

const addContactUsDetails = (micrositeId, tabConfigId) =>
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/contact-us?tabConfigId=${tabConfigId}`;

const getAboutUsDetails = (tabName, micrositeId, id) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/about-us-details?aboutUsEnum=${tabName}`
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/about-us-details?aboutUsEnum=${tabName}&tabConfigId=${
    id || ""
  }`;

const putAboutUsDetails = (micrositeId) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details/about-us`
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details`;

// const getAllSkills = () => `${API_URL}/organization-admin/getSkills`;
const getAllSkills = () =>
  // `${API_URL}/get-skills`;
  `${API_URL}/organization-admin/getSkills`;

const publishMicrosite = (micrositeId) =>
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}`;

const login = () => `${API_URL}/login`;

const forgotPassword = () => `${API_URL}/forgot-password`;

const changePassword = () => `${API_URL}/change-password`;

const help = () =>
  `${API_URL}/organization-admin/getHelpSection?userRole=ORGANIZATION_ADMIN`;

const getHelpByTab = (tab) =>
  // `${API_URL}/organization-admin/getHelpSectionByTab?userRole=ORGANIZATION_ADMIN&${tab ? `assetType=${tab}&` : ""}`;
  `${API_URL}/organization-admin/getHelpSection?userRole=ORGANIZATION_ADMIN`;

const getFilteredHelpInfo = (userRole, searchKey, tab) =>
  // `${API_URL}/end-user/help-section/search/?userRole=${userRole}&text=${searchKey}&${tab ? `&assetType=${tab}` : ""}`;
  `${API_URL}/end-user/help-section/search/?userRole=${userRole}&text=${searchKey}`;

const createOrganizationUser = () => `${API_URL}/register-organization-admin`;

const referOrganisation = (partnerId, email) =>
  `${API_URL}/refer-organisation/${partnerId}?email=${email}`;

const createMicrositeTabs = (activateKey, micrositeId) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details/${activateKey}`;
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details`;

const createApprenticeshipVacancies = (micrositeId) =>
  `${API_URL}/organization-admin/organization/microsite/vacancy/${micrositeId}`;

const deleteApprenticeshipVacancies = (micrositeId, tabName, id) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/${tabName}/${id}`;
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/${id}`;

const getMicrositeDetailsTabs = (tabName, micrositeId, tabId) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details?section=${tabName}`;
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details?tabConfigId=${tabId}`;

const updateMicrositeDetailsTabs = (tabName, micrositeId, id) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details/tabConfigId/${id}`;
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details`;

const deleteMicrositeDetailsTabs = (micrositeId, tabName, id) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details/${tabName}/${id}`;
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details/${id}`;

const deleteContractTab = (id) =>
  `${API_URL}/organization-admin/organization/deleteContracts/${id}`;

const experienceOfWork = (micrositeId) =>
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/details/work-experience`;

const getMicrositeDetailsVacancyTab = (tabName, micrositeId, tabConfigId) =>
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/vacancy?apprenticeshipType=${tabName}&tabConfigId=${tabConfigId}`;

const getMicrositeDetailsContractTab = (micrositeId, tabConfigId) =>
  `${API_URL}/organization-admin/organization/contracts/${micrositeId}?tabConfigId=${tabConfigId}`;

const createContractDetails = (micrositeId) =>
  `${API_URL}/organization-admin/organization/addContracts/${micrositeId}`;

const updateContractDetails = (micrositeId) =>
  `${API_URL}/organization-admin/organization/updateContracts/${micrositeId}`;

const getPreviewExperienceofWorkTab = (micrositeId) =>
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/experience-of-work-toggled-on`;

const adminOrganization = () => `${API_URL}/organization-admin/organization`;

const getProfile = () => `${API_URL}/organization-admin/profile`;

const updateProfile = () => `${API_URL}/organization-admin/profile`;
const settings = (micrositeId) =>
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/site-settings`;
const getSettings = (partnerId, micrositeId) =>
  // `${API_URL}/organization-admin/microsite/${micrositeId}/partner/pro-settings?partnerId=${partnerId}`;
  `${API_URL}/organization-admin/get-tabs-settings/microsite/${micrositeId}`;

const putSettings = (partnerId, micrositeId) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/pro-settings?partnerId=${partnerId}`
  `${API_URL}/organization-admin/update-tab-toggle/microsite`;

const resetPassword = (token) =>
  `${API_URL}/reset-password/reset?token=${token}`;

const geteof = (micrositeId) =>
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/experience-of-work`;

const updateeof = (micrositeId, id) =>
  // `${API_URL}/organization-admin/organization/microsite/${micrositeId}/experience-of-work/${id}`;
  `${API_URL}/organization-admin/organization/microsite/experience-of-work/${id}`;

const geteofOP = () => `${API_URL}/experience-of-work-opportunity`;

// not being used using getMasterDataType()
// const geteoftitle = () => `${API_URL}/get-work-experience-title`;

const geteofopportunitytitle = () =>
  `${API_URL}/experience-of-work-opportunity`;

const partnerDetails = (partnerId) =>
  `${API_URL}/organization-admin/organization-partner-details?${
    partnerId ? `partnerId=${partnerId}` : ""
  }`;

const getPartnerDetailsLoginScreen = (partnerId) =>
  `${API_URL}/login?${partnerId ? `subDomainName=${partnerId}` : ""}`;

const getSubDomainDetails = (partnerId) =>
  `${API_URL}/get-partner-name?${partnerId ? `partnerId=${partnerId}` : ""}`;

const getInsuranceFile = (micrositeId) =>
  `${API_URL}/organization-admin/insuranceDocs/${micrositeId}`;

const uploadInsuranceDoc = (micrositeId) =>
  `${API_URL}/organization-admin/uploadDocument/${micrositeId}`;

const feedbackForm = () =>
  // `${API_URL}/organization-admin/org-feedback`;
  `${API_URL}/organization-admin/addFeedback`;

const deleteInsuranceDoc = (documentId) =>
  `${API_URL}/organization-admin/deleteDocument/${documentId}`;

const createMulMicrosite = () =>
  `${API_URL}/organization-admin/organization/microsite`;

const deleteMicrosite = (micrositeID) =>
  `${API_URL}/organization-admin/deleteMicrosite/${micrositeID}`;

const duplicateMicrosite = (micrositeID) =>
  `${API_URL}/organization-admin/newmicrosite/${micrositeID}`;

const getMasterDataType = (type) =>
  // `${API_URL}/organization-admin/getlevels`;
  `${API_URL}/organization-admin/master-data/${type}`;

const getReviews = (micrositeId) =>
  `${API_URL}/organization-admin/organization/microsite/${micrositeId}/getReviews`;

const replyReview = () =>
  `${API_URL}/organization-admin/organization/microsite/addReview`;

const deleteReview = (reviewId) =>
  `${API_URL}/organization-admin/organization/sendrequest/${reviewId}`;

const deleteReviewReply = (reviewId) =>
  `${API_URL}/end-user/organization/microsite/deleteReview/${reviewId}`;

const getTeamsCoursesProducts = (micrositeID, tabConfigId) =>
  // `${API_URL}/organization-admin/microsite/${micrositeID}/get-section-titles?sectionName=${sectionName}`;
  `${API_URL}/organization-admin/microsite/${micrositeID}/get-section-titles?tabConfigId=${tabConfigId}`;

const saveTeamsCoursesProducts = (micrositeID, tabConfigId) =>
  // `${API_URL}/organization-admin/microsite/${micrositeID}/section-title?sectionName=${sectionName}`;
  `${API_URL}/organization-admin/microsite/${micrositeID}/section-title?tabConfigId=${tabConfigId}`;

const deleteTeamsCoursesProduct = (id) =>
  `${API_URL}/organization-admin/microsite-title/${id}`;

const deleteBrochure = (brochureId) =>
  `${API_URL}/end-user/delete-brochure/${brochureId}`;

const overallViewCount = (orgId) =>
  `${API_URL}/organization-admin/org-analytics/total/?organizationId=${orgId}`;

const orgAnalytics = (orgId, month, year, quarter) =>
  `${API_URL}/organization-admin/org-analytics/total-organization?organizationId=${orgId}${
    month ? `&month=${month}` : ""
  }${year ? `&year=${year}` : ""}${quarter ? `&quarter=${quarter}` : ""}`;

const locationAnalytics = (
  orgId,
  ageID,
  profID,
  filterType,
  year,
  month,
  quarter
) =>
  `${API_URL}/organization-admin/organization-analytics/location?organizationId=${orgId}${
    ageID ? `&ageGroupId=${ageID}` : ""
  }
${profID ? `&tagId=${profID}` : ""}${
    filterType ? `&filterType=${filterType}` : ""
  }${year ? `&year=${year}` : ""}
${month ? `&month=${month}` : ""}${quarter ? `&quarter=${quarter}` : ""}`;

const orgOverallMicrositeAnalytics = (orgId, month, year, quarter) =>
  `${API_URL}/organization-admin/org-analytics/microsite/monthly?organizationId=${orgId}${
    month ? `&month=${month}` : ""
  }${year ? `&year=${year}` : ""}${quarter ? `&quarter=${quarter}` : ""}`;

const getMicrositeAnalytics = (micrositeId, month, year, quarter) =>
  `${API_URL}/organization-admin/microsite/contactUs/total?micrositeId=${micrositeId}${
    month ? `&month=${month}` : ""
  }${year ? `&year=${year}` : ""}${quarter ? `&quarter=${quarter}` : ""}`;

const getProfessions = (ageGroupID) =>
  `${API_URL}/partner-admin/end-user-tags/age-group/${ageGroupID}`;
// `${API_URL}/end-user/master-data/${ageGroupID}`;

// const getOnOrganisationType = (partnerId) =>
//   `${API_URL}/get-all-orgType/${partnerId}?toggle=true`;

const getOnOrganisationType = (partnerId) =>
  `${API_URL}/end-user/org-partner-types/${partnerId}/ORGANIZATION_TYPE`;

const downloadOrgEngagementCSV = (orgId) =>
  `${API_URL}/organization-admin/user-info/downloadCSV?organizationId=${orgId}`;

const getMicroSiteTabConfig = (micrositeId) =>
  `${API_URL}/organization-admin/all-tabs/${micrositeId}`;

const checkPartnerstatus = (token) =>
  `${API_URL}/check-for-org-partner-delete?token=${token}`;

const getCompanyTypes = () =>
  `${API_URL}/organization-admin/master-data/COMPANY_TYPE`;

const getSectionTitles = (micrositeID, tabConfigId) =>
  `${API_URL}/organization-admin/microsite/${micrositeID}/get-section-titles?tabConfigId=${tabConfigId}`;

const getDefaultSectionTitles = (type) =>
  `${API_URL}/organization-admin/master-data/${type}`;

const addSectionTitle = (micrositeID, tabConfigId) =>
  `${API_URL}/organization-admin/microsite/${micrositeID}/section-title?tabConfigId=${tabConfigId}`;

const deleteSectionTitle = (titleId) =>
  `${API_URL}/organization-admin/microsite-title/${titleId}`;

const reArrangeDataInAboutUs = ({micrositeId,aboutUsEnum,tabConfigId}) => (
  `${API_URL}/organization-admin/re-arrange-our-clients?aboutUsEnum=${aboutUsEnum}&micrositeId=${micrositeId}&tabConfigId=${tabConfigId}`
)
export default {
  addOrganization,
  getDefaultSectionTitles,
  refreshToken,
  getAllCountries,
  getAllSectors,
  getSubSectors,
  getAllMicrosites,
  createMicrosite,
  createMicrositeTabs,
  createContactUsSales,
  updateContactUsSales,
  createContactUsAddress,
  getAllSkills,
  getSingleOrganization,
  updateOrganization,
  publishMicrosite,
  login,
  forgotPassword,
  createApprenticeshipVacancies,
  getMicrositeDetailsTabs,
  getMicrositeDetailsVacancyTab,
  getMicrositeDetailsContractTab,
  createContractDetails,
  updateContractDetails,
  getPreviewExperienceofWorkTab,
  getContactUsDetails,
  getAboutUsDetails,
  putAboutUsDetails,
  adminOrganization,
  getProfile,
  updateProfile,
  changePassword,
  help,
  getHelpByTab,
  getFilteredHelpInfo,
  createOrganizationUser,
  experienceOfWork,
  deleteApprenticeshipVacancies,
  updateMicrositeDetailsTabs,
  deleteMicrositeDetailsTabs,
  deleteContractTab,
  settings,
  getSettings,
  putSettings,
  referOrganisation,
  resetPassword,
  geteof,
  updateeof,
  geteofOP,
  // geteoftitle,
  geteofopportunitytitle,
  partnerDetails,
  getPartnerDetailsLoginScreen,
  getSubDomainDetails,
  uploadInsuranceDoc,
  feedbackForm,
  getInsuranceFile,
  deleteInsuranceDoc,
  createMulMicrosite,
  deleteMicrosite,
  duplicateMicrosite,
  getMasterDataType,
  getReviews,
  replyReview,
  deleteReview,
  deleteReviewReply,
  getTeamsCoursesProducts,
  saveTeamsCoursesProducts,
  deleteTeamsCoursesProduct,
  deleteBrochure,
  overallViewCount,
  orgAnalytics,
  locationAnalytics,
  orgOverallMicrositeAnalytics,
  getMicrositeAnalytics,
  getProfessions,
  getOnOrganisationType,
  downloadOrgEngagementCSV,
  getMicroSiteTabConfig,
  checkPartnerstatus,
  getCompanyTypes,
  getSectionTitles,
  addSectionTitle,
  deleteSectionTitle,
  addContactUsDetails,
  reArrangeDataInAboutUs
};
